import { alpha, Theme } from '@mui/material';
import { useBlendColors } from 'hooks/useDesign';

export default {
    rightPanel: {
        height: '100%',
        overflow: 'hidden',
        flexGrow: 1,
    },
    announcementHolder: {
        flexShrink: 0,
        maxHeight: '50%',
        overflow: 'hidden',
        '&.announcement-wrapper--expanded': {
            maxHeight: 'none',
            flexGrow: 1,
            flexShrink: 1,
        },
        '#announcementList': {
            padding: 0,
            pt: 3,
            px: '24px',
        },
    },
    filterPanelHolder: {
        borderBottom: '1px solid',
        borderColor: (theme: Theme) => useBlendColors(alpha(theme.palette.text.primary, 0.08)),
    },
    logoAndCollapseHolder: {
        flexShrink: 0,
    },
    hierarchyBtnHolder: {
        borderRight: '1px solid',
        borderColor: (theme: Theme) => useBlendColors(alpha(theme.palette.text.primary, 0.08)),
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '41px',
    },
    logoHolder: {
        flexShrink: 0,
        pl: 2,
        pr: 1.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRight: '1px solid',
        borderColor: (theme: Theme) => useBlendColors(alpha(theme.palette.text.primary, 0.08)),
    },
    logoImg: {
        maxWidth: '120px',
        maxHeight: '28px',
    },
};
